export function formatShortCodeForDisplay(shortCode: string) {
  if (!shortCode) return ''
  return shortCode.replace(/^([2-9A-Z]{3})([2-9A-Z]{3})([2-9A-Z]{3})$/g, '$1-$2-$3')
}
